export default __webpack_public_path__ + "static/media/dab.c822bed0.jpeg";